export default __webpack_public_path__ + "static/emergency-management-17a016174a5707381c711f7b94aa8b51.png";